module.exports = __webpack_public_path__ + "media/about.bb9dde15.mp4";